<div *ngIf="isModal"
     (click)="onClicked()">
    <ng-content></ng-content>
</div>
<mat-card *ngIf="!isModal">
    <auth-form [title]="title"
               [image]="image"
               [nextUrl]="nextUrl"
               [defaultNextUrl]="defaultNextUrl"
               [isRegistrationDisabled]="isRegistrationDisabled">
    </auth-form>
</mat-card>
